import { render, staticRenderFns } from "./SampleVueTree.vue?vue&type=template&id=4b48937a&scoped=true&"
import script from "./SampleVueTree.vue?vue&type=script&lang=js&"
export * from "./SampleVueTree.vue?vue&type=script&lang=js&"
import style0 from "./SampleVueTree.vue?vue&type=style&index=0&id=4b48937a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48937a",
  null
  
)

export default component.exports